'use es6';

import { PureComponent } from 'react';
import { findDOMNode } from 'react-dom';
import { throttle } from 'underscore';
import { jsx as _jsx } from "react/jsx-runtime";
const THROTTLE_TIME = 200;
const PIXEL_OFFSET = 100;
const HOC = Component => {
  class WithVisibilityChecker extends PureComponent {
    constructor(props) {
      super(props);
      this.handleScroll = throttle(this.handleScroll.bind(this), THROTTLE_TIME);
      this.updateVisibility = this.updateVisibility.bind(this);
      this.state = {
        isVisible: false
      };
    }
    componentDidMount() {
      this.timeout = setTimeout(() => {
        this.node = findDOMNode(this);
        this.updateVisibility();
      }, 0);

      /* Have to do both wheel and scroll, module forms do no scroll document, but settings does */
      document.addEventListener('scroll', this.handleScroll);
      document.addEventListener('wheel', this.handleScroll);
    }
    componentWillUnmount() {
      if (this.timeout) clearTimeout(this.timeout);
      document.removeEventListener('scroll', this.handleScroll);
      document.removeEventListener('wheel', this.handleScroll);
    }
    updateVisibility() {
      if (!this.node) return;
      const {
        top
      } = this.node.getBoundingClientRect();
      const isVisible = top < window.innerHeight + PIXEL_OFFSET && top > -PIXEL_OFFSET;
      if (this.state.isVisible !== isVisible) {
        this.setState({
          isVisible
        });
      }
    }
    handleScroll() {
      this.updateVisibility();
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        isVisible: this.state.isVisible
      }));
    }
  }
  return WithVisibilityChecker;
};
export default function withVisibilityChecker() {
  return HOC;
}